import { makeActionCreator } from '../../../utilities'
import { ProcedureConstants } from './procedure.constants'

export const setInputRows = makeActionCreator(ProcedureConstants.SET_INPUT_ROWS, 'inputRows')
export const setAssessedByOptions = makeActionCreator(ProcedureConstants.SET_ASSESSED_BY_OPTIONS, 'assessedByOptions')
export const setAuthorizationOptions = makeActionCreator(
  ProcedureConstants.SET_AUTHORIZATION_OPTIONS,
  'authorizationOptions'
)
export const setComplicationsOptions = makeActionCreator(
  ProcedureConstants.SET_COMPLICATIONS_OPTIONS,
  'complicationsOptions'
)
export const setResponseValueOptions = makeActionCreator(ProcedureConstants.SET_RESPONSE_OPTIONS, 'responseOptions')
export const setRolePerformingOptions = makeActionCreator(
  ProcedureConstants.SET_ROLE_PERFORMING_OPTIONS,
  'rolePerformingOptions'
)
export const setIsFirstVisit = makeActionCreator(ProcedureConstants.SET_IS_FIRST_VISIT, 'isFirstVisit')
export const setNemsisCodeOptions = makeActionCreator(ProcedureConstants.SET_NEMSIS_CODE_OPTIONS, 'nemsisCodeOptions')
